export default "__VITE_IMAGE_ASSET__4e5e596d__";